import { render, staticRenderFns } from "./ChartColoredPeriodTooltip.vue?vue&type=template&id=d04396c6&scoped=true"
import script from "./ChartColoredPeriodTooltip.vue?vue&type=script&lang=ts"
export * from "./ChartColoredPeriodTooltip.vue?vue&type=script&lang=ts"
import style0 from "./ChartColoredPeriodTooltip.vue?vue&type=style&index=0&id=d04396c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04396c6",
  null
  
)

export default component.exports